module.exports = __webpack_public_path__ + "02_short_brown.db76e86f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/02_short_brown.png
// module id = LKko
// module chunks = 0